/**
 * Copyright Mántum All Rights Reserved.
 */
import Button from '..';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import type { PropTypes } from '..';

export default function Text(props: PropTypes) {
    return (
        <div className='w-full divide-x divide-accent-dark flex'>
            <Button
                className='inline-flex h-10 w-full items-center justify-center border border-transparent bg-accent px-4 py-2 rounded-l-md text-base font-medium outline-offset-2 outline-accent-dark hover:bg-accent-dark'
                loading={props.loading}
                onClick={props.onClick}
                testid={props.testid}
                title={props.title}
                truncate={props.truncate}
                type={props.type}
            >
                {props.children}
            </Button>
            <div>
                <button
                    className='inline-flex h-10 items-center justify-center border border-transparent bg-accent p-2 rounded-r-md outline-offset-2 outline-accent-dark hover:bg-accent-dark'
                    type='button'
                >
                    <ChevronDownIcon className='h-3 w-3' />
                </button>
            </div>
        </div>
    );
}
